import { violet } from '@klaviyo-mkt/design-system/dist/typescript/colors';
import Button from '@klv/atoms/button';
import Icon from '@klv/atoms/icon';
import { Rive } from '@klv/atoms/rive';
import { generateClassName } from '@klv/shared/utils/functions';

import kaiBackground from './static/purple-gradient.svg';
import kaiBackground2 from './static/K_AI.webp';


import * as styles from './styles/homepageKbosKaiTemp.module.css';

import type { IHomepageKbosKaiTemp } from './types';

export const HomepageKbosKaiTemp = ({
  className = '',
  eyebrowIcon,
  eyebrow,
  headline,
  step1,
  step2,
  step3,
  buttonLabel,
  buttonLink,
  buttonTarget,
  riveAnimation,
  ...props
}: IHomepageKbosKaiTemp) => {
  // Extract rive data if available
  const riveFile = riveAnimation?.riveFile;
  const layout = riveAnimation?.riveData?.layout;
  const textRuns = riveAnimation?.riveData?.textRuns || [];
  const ariaLabel = riveAnimation?.riveData?.ariaLabel;

  return (
    <div 
      className={generateClassName([className, styles.homepageKbosKaiTemp])}
      {...props}
      style={{
        '--homepage-kbos-kai-temp-background-image': `url(${kaiBackground})`,
        '--homepage-kbos-kai-temp-background-image-2': `url(${kaiBackground2})`,
      } as React.CSSProperties}
    >
      <div className={styles.content}>
        
        {/* Eyebrow section */}
        {eyebrow && (
          <div className={styles.eyebrow}>
            {eyebrowIcon?.iconName && (
              <Icon 
                iconName={eyebrowIcon.iconName} 
                className={styles.eyebrowIcon} 
                fillColor={violet}
              />
            )}
            <span>{eyebrow}</span>
          </div>
        )}

        {/* Headline */}
        {headline && (
          <h1 className={generateClassName([styles.headline, 'h1', 'semibold'])} dangerouslySetInnerHTML={{ __html: headline }} />
        )}

        {/* Steps */}
        <div className={styles.steps}>
          {step1 && (
            <span className={generateClassName(['p2 semibold'])}>{step1}</span>
          )}
          <Icon iconName='ArrowDown' />
          {step2 && (
            <span className={generateClassName(['p2 semibold'])}>{step2}</span>
          )}
          <Icon iconName='ArrowDown' />
          {step3 && (
            <span className={generateClassName(['p2 semibold'])}>{step3}</span>
          )}
        </div>

        {/* Button */}
        {buttonLabel && buttonLink && (
          <Button
            text={buttonLabel}
            url={buttonLink}
            openInNewTab={buttonTarget === '_blank'}
            variant="primary"
            className={styles.button}
          />
        )}

        {/* Rive Animation */}
        {riveFile?.mediaItemUrl && (
          <div className={styles.riveContainer}>
            <Rive
              riveFile={riveFile}
              aspectRatio={layout?.aspectRatio}
              flexibleLayout={layout?.isFlexible}
              height={layout?.height}
              riveText={textRuns}
              ariaLabelText={ariaLabel}
              className={styles.rive}
            />
          </div>
        )}
      </div>
    </div>
  );
};
